<template>
	<header class="pt-600-smo pt-800-md pb-400 bg-color-content-primary text-color-white">
		<div :class="containerStyles">
			<div
				:class="[
					'text-align-center-smo col-12-smo col-7-md',
					{
						'display-flex flex-direction-column justify-content-space-between gap-100 mt-150-md':
							props.hero.disclaimer
					}
				]"
			>
				<div v-reveal:fade-up class="col-10-md">
					<slot name="heading">
						<h1 class="heading-1"> {{ props.hero.heading }} </h1>
					</slot>
					<p class="body-xl mt-25-md mt-100-smo"> {{ props.hero.subheading }} </p>
					<p class="body-lg">
						{{ props.hero.description }}
					</p>
					<LeadCaptureOcf :config="props.hero.leadCaptureConfig" button-color="button-primary" />
				</div>
				<div v-if="props.hero.disclaimer" class="text-color-gray-30 body-xs">
					{{ props.hero.disclaimer }}
				</div>
			</div>
			<div class="col-12-smo col-offset-1-md col-4-md mt-250-smo">
				<div v-reveal:fade-up class="bb bt br bl border-color-reversed">
					<table class="display-block px-100 pt-100">
						<thead class="display-block mb-50">
							<th class="font-weight-bold text-transform-uppercase">Fund structure</th>
						</thead>
						<tbody class="display-block">
							<tr
								v-for="(detail, index) in props.fundStructureDetails"
								:key="index"
								class="border-color-reversed body-sm display-flex justify-content-space-between py-100 gap-25"
								:class="{ bt: index !== 0 }"
							>
								<td v-html="detail.key" />
								<td class="font-weight-bold text-align-right" v-html="detail.value" />
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { KeyValue } from 'types/layout';
import LeadCaptureOcf from '@components/lead-capture/lead-capture-ocf.vue';
import { OcfConfig } from 'types/layout/lead';

interface Props {
	hero: {
		heading: string;
		subheading: string;
		description: string;
		disclaimer?: string;
		leadCaptureConfig: OcfConfig;
	};
	fundStructureDetails: Array<KeyValue>;
}

const props = defineProps<Props>();

const containerStyles = computed(() => {
	const baseStyles = 'container display-flex-md';
	const alignment = props.hero.disclaimer ? 'align-items-stretch' : 'align-items-center';
	return `${baseStyles} ${alignment}`;
});
</script>
<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;

@include respond-to(md) {
	.pt-800-md {
		padding-top: 8rem;
	}
}
</style>
